<template>
<!--  icon:info , clock-circle, home,form,edit -->
<a-spin :spinning="isLoading">
  <div class="css-func">
    <a-divider v-if="admin_apps.length>0" orientation="left">管理</a-divider>
    <div v-if="admin_apps.length>0" class="css-admin-layer">
      <a-row :gutter="10" v-for="(funcs,index) in admin_apps_arrarr">
        <a-col :span="8" v-for="(func,i) in funcs">
          <a-button class="app-btn" @click="onAppClicked(func)">
            <a-icon :type="func.icon" />
            <p>{{func.name}}</p>
          </a-button>
        </a-col>
      </a-row>
    </div>

    <a-divider orientation="left">各種申請</a-divider>
    <div class="css-employee-layer">
      <a-row :gutter="10" v-for="(funcs,index) in employee_apps_arrarr">
        <a-col :span="8" v-for="(func,i) in funcs">
          <a-button class="app-btn" @click="onAppClicked(func)">
            <a-icon :type="func.icon" />
            <p>{{func.name}}</p>
          </a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider orientation="left">設定</a-divider>
    <div class="css-employee-layer">
      <a-row :gutter="10" v-for="(funcs,index) in settings_apps_arrarr">
        <a-col :span="8" v-for="(func,i) in funcs">
          <a-button class="app-btn" @click="onAppClicked(func)">
            <a-icon :type="func.icon" />
            <p>{{func.name}}</p>
          </a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</a-spin>
</template>

<script>
export default {
  name: "functions",
  data() {
    return {
      isLoading: false,
      admin_apps: [],
      employee_apps: [],
      settings_apps: []
    };
  },
  computed: {
    admin_apps_arrarr: {
      get: function() {
        return this.arr2arrarr(this.admin_apps);
      }
    },
    employee_apps_arrarr: {
      get: function() {
        return this.arr2arrarr(this.employee_apps);
      }
    },
    settings_apps_arrarr: {
      get: function() {
        return this.arr2arrarr(this.settings_apps);
      }
    }
  },
  methods: {
    arr2arrarr(ain) {
      let arrarr = [];
      for (let i = 0; i < ain.length; i += 3) {
        let arr = [ain[i]];
        if (i + 1 < ain.length) arr.push(ain[i + 1]);
        if (i + 2 < ain.length) arr.push(ain[i + 2]);
        arrarr.push(arr);
      }
      return arrarr;
    },
    onNotifyForIdenti() {
      console.log("notification effective.")
      var compResidDate= this.$moment(new Date()).add(3, 'M').format('YYYY/MM/DD');
      var tarResidDate=this.$moment(this.$store.getters.info.employeeinfo.residence_card_expired).format('YYYY/MM/DD');

      var compPassDate= this.$moment(new Date()).add(6, 'M').format('YYYY/MM/DD');
      var tarPassDate= this.$moment(this.$store.getters.info.employeeinfo.passport_expired).format('YYYY/MM/DD');
      console.log("test7:"+tarPassDate);
  
      if(this.$moment(compPassDate).isAfter(tarPassDate) && this.$moment(compResidDate).isAfter(tarResidDate)){
        this.$notification.warn({
          message:"注意",
          description:"あなたのパスポートと在留カードは間もなく期限切れです。入国管理局と中国大使館にお越し、それぞれをご更新ください。"
        });
      } else if(this.$moment(compPassDate).isAfter(tarPassDate)){
        this.$notification.warn({
          message:"注意",
          description:"あなたのパスポートの有効期限は"+this.$store.getters.info.employeeinfo.passport_expired+"までです。中国大使館にお越し、パスポートをご更新ください。"
        });
      } else if(this.$moment(compResidDate).isAfter(tarResidDate)){
        this.$notification.warn({
          message:"注意",
          description:"あなたの在留カード有効期限は"+this.$store.getters.info.employeeinfo.residence_card_expired+"までです。入国管理局にお越し、またはオンラインシステムをご利用ください。"
        });
      } else{
        console.log("期限内.");
      }
    },
    onAppClicked(value) {
      let info = this.$store.getters.info;
      this.$logger.d("AppPanel", "onAppClicked", {
        value: value,
        info: info
      });

      switch (value.key) {
        case "employeelist":
          this.$router.push({
            name: "employeelist"
          });
          break;
        case "transexp_control":
          this.$router.push({
            name: "transexp_control"
          });
          break;
        case "workinghours_control":
          this.$router.push({
            name: "workinghours_control"
          });
          break;
        case "info":
          this.$router.push({
            name: "info"
          });
          break;
        case "password":
          this.$router.push({
            name: "change_password"
          });
          break;
        case "transexp":
          this.$router.push({
            name: "transexp",
            params: {
              eid: info.eid
            }
          });
          break;
        case "workinghours":
          this.$router.push({
            name: "workinghours",
            params: {
              eid: info.eid
            }
          });
          break;
        case "calendarLink":
           this.$router.push({
            name: "calendarlink"
          });
          break;
      }
    }
  },
  created: function() {
    let token = this.$store.getters.token;
    if (!token) {
      return this.$router.push({
        path: "/login"
      });
    } else {
      this.isLoading = true;
      this.$api.employee
        .queryOne({
          token: token
        })
        .then(data => {
          let resp = data.data;

          if (resp.error) {
            // if(resp.error.code == "020003"){
            //   this.$store.dispatch("logout");
            //   this.$router.push({
            //     path: "/login"
            //   });
            // }
            // this.$notification.error({
            //   message: "エラー:" + resp.error.code,
            //   description: resp.error.description
            // });
            this.$error_handler(this,resp.error)
          } else {
            let permissions = resp.result.employee.permissions
            this.admin_apps = []
            console.log(permissions)
            if (permissions.filter(p => p.name === this.$permissions.get.employee).length > 0) {
              this.admin_apps.push({
                key: "employeelist",
                icon: "team",
                name: "社員一覧"
              })
            }
            if (permissions.filter(p => p.name === this.$permissions.get.workinghours).length > 0) {
              this.admin_apps.push({
                key: "workinghours_control",
                icon: "file-done",
                name: "勤務時間"
              })
            }
            if (permissions.filter(p => p.name === this.$permissions.get.transexp).length > 0) {
              this.admin_apps.push({
                key: "transexp_control",
                icon: "audit",
                name: "交通費"
              })
            }

            this.employee_apps = [{
                key: "workinghours",
                icon: "clock-circle",
                name: "勤務時間申請"
              },
              {
                key: "transexp",
                icon: "form",
                name: "交通費申請"
              },
              {
                key: "calendarLink",
                icon: "calendar",
                name: "事務カレンダー"
              }
            ];
            this.settings_apps = [{
              key: "info",
              icon: "idcard",
              name: "個人"
            }, {
              key: "password",
              icon: "key",
              name: "パスワード"
            }]
          }
          this.isLoading = false;
          this.onNotifyForIdenti();
        })
        .catch(err => {
          this.$logger.e("AppPanel", "created", {
            error: err
          });
          this.$notification.error({
            message: "エラー",
            description: "サーバ通信エラー"
          });
        });
    }
  },
  mounted: function() {
    this.$logger.d("AppPanel", "mounted", {
      admin_apps: this.admin_apps_arrarr,
      employee_apps: this.employee_apps_arrarr
    });
  }
};
</script>
<style scoped>
.css-func {}

.css-admin-layer {
  padding: 0px 15px 15px 15px;
}

.css-employee-layer {
  padding: 0px 15px 15px 15px;
}

.css-func>>>.ant-row {
  margin-top: 20px;
}

.app-btn {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.app-btn>>>.anticon {
  font-size: 30px;
}

.app-btn .p {
  float: bottom;
}
</style>
